import gql from 'graphql-tag';

const getVideoPaymentStatusQuery = gql`
  query GetVideoPaymentStatus($videoId: String!) {
    getVideoPaymentStatus(videoId: $videoId) {
      status
      refundedDate
      paymentDate
    }
  }
`;

const getVideoPaymentStatus = () => ({
  query: getVideoPaymentStatusQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({ videoId }: { videoId?: string }) => ({
    videoId
  })
});

export default getVideoPaymentStatus;
